import { createBrowserRouter, Navigate, Outlet, RouterProvider, useParams } from 'react-router-dom'
import { AuthProvider } from './lib/auth'
import { SettingsProvider } from './lib/settings'
import { tagPath } from './lib/format'
import { ComicPage } from './views/ComicPage'
import { FeedPage } from './views/FeedPage'
import { AboutPage, ContactPage, NewsletterConfirmPage, NotFoundPage, UnsubscribePage } from './views/InfoPages'
import { LoginPage } from './views/LoginPage'
import { CommentsPage, EditPage, ManagePage, ManageTagsPage, NewNewsletterPage, NewsletterPage, PreviewPage, SentNewsletterPage, SettingsPage, UploadPage } from './views/ArtistPages'

function Root() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Outlet />
      </SettingsProvider>
    </AuthProvider>
  )
}

/** Tag pages were called categories before 2026-10-16 */
function OldCategory() {
  const { tag = '' } = useParams()
  return <Navigate to={tagPath(tag)} replace />
}

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: '/', element: <FeedPage mode="home" /> },
      { path: '/tag/:tag', element: <FeedPage mode="tag" /> },
      { path: '/search', element: <FeedPage mode="search" /> },
      { path: '/comic/:slug', element: <ComicPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/newsletter/confirm', element: <NewsletterConfirmPage /> },
      { path: '/newsletter/unsubscribe', element: <UnsubscribePage /> },
      { path: '/login', element: <LoginPage /> },
      { path: '/artist/upload', element: <UploadPage /> },
      { path: '/artist/edit/:id', element: <EditPage /> },
      { path: '/artist/preview/:id', element: <PreviewPage /> },
      { path: '/artist/comics', element: <ManagePage /> },
      { path: '/artist/tags', element: <ManageTagsPage /> },
      { path: '/artist/comments', element: <CommentsPage /> },
      { path: '/artist/newsletter', element: <NewsletterPage /> },
      { path: '/artist/newsletter/new', element: <NewNewsletterPage /> },
      { path: '/artist/newsletter/sent/:sentAt', element: <SentNewsletterPage /> },
      { path: '/artist/settings', element: <SettingsPage /> },
      // Old addresses from the first version of the site
      { path: '/upload', element: <UploadPage /> },
      { path: '/category/:tag', element: <OldCategory /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
